app.service('subjectMapService', function ($http, apiService) {

  this.getSubjectMapURL = function (obj) {
    // If map is in local storage, load it, otherwise, load it from the server
    if (localStorage.getItem('subject_map')) {
      return new Promise((resolve, reject) => {
        let subject_map = localStorage.getItem('subject_map')
        resolve(subject_map)
      })
    } else {
      return new Promise((resolve, reject) => {
        img             = new Image()
        img.crossOrigin = "anonymous"
        img.src         = apiService.setSubjectMap({ lng: obj.lng, lat: obj.lat })
        img.onload      = function () {
          let canvas        = document.createElement('canvas')
              canvas.width  = img.width
              canvas.height = img.height
          let ctx           = canvas.getContext('2d')
          ctx.drawImage(img, 0, 0)
          let dataURL = canvas.toDataURL('image/png')
          localStorage.setItem('subject_map', dataURL)
          resolve(dataURL)
        }
      })

    }
  }

})